// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"fD","label":"fE","downloadSize":"fF","selectorWrapper":"fG","selected":"fH"};